<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab22.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">password</span>
                                    <div class="list-number"><span>1.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab22.text1', $t, localPath)"></span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">variable_insert</span>
                                    <div class="list-number"><span>2.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab22.text2") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/Manage-my-account-q2-01-movil.png"><img src="/images/faq/Manage -my-account-q2-01.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">input_circle</span>
                                    <div class="list-number"><span>3.</span></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab22.text3") }}</span></p>
                                        <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/Manage-my-account-q2-02-movil.jpg"><img src="/images/faq/Manage-my-account-q2-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                    </div>
                                    </div>
                                </div>
                                <!-- <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">currency_bitcoin</span>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab22.text4', $t, localPath)"></span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text5") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text6") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text7") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text8") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text9") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text10") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text11") }}</span></p>
                                    </div>
                                    </div>
                                </div> -->
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">credit_card</span>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab22.text19', $t, localPath)"></span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text20") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text21") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text22") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text23") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text24") }}</span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">account_balance_wallet</span>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab22.text12', $t, localPath)"></span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text13") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text14") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text15") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text16") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text17") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text18") }}</span></p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon">
                                    <span class="material-symbols-outlined icon" translate="no">account_balance</span>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span v-html="formatContent('faq.tab22.text25', $t, localPath)"></span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text26") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text27") }}</span></p>
                                        <p class="body-4"><span >{{ $t("faq.tab22.text28") }}</span></p>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                    <div class="content-main-tab">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab22.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">password</span>
                                <div class="list-number"><span>1.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab22.text1', $t, localPath)"></span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">variable_insert</span>
                                <div class="list-number"><span>2.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab22.text2") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/Manage-my-account-q2-01-movil.png"><img src="/images/faq/Manage -my-account-q2-01.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">input_circle</span>
                                <div class="list-number"><span>3.</span></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab22.text3") }}</span></p>
                                    <picture class=""><source media="(max-width: 570px)" srcset="/images/faq/Manage-my-account-q2-02-movil.jpg"><img src="/images/faq/Manage-my-account-q2-02.png" alt="Imagen 1" class="responsive-image"></picture>
                                </div>
                                </div>
                            </div>
                            <!-- <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">currency_bitcoin</span>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab22.text4', $t, localPath)"></span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text5") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text6") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text7") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text8") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text9") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text10") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text11") }}</span></p>
                                </div>
                                </div>
                            </div> -->
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">credit_card</span>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab22.text19', $t, localPath)"></span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text20") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text21") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text22") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text23") }}</span></p>
                                    <!-- <p class="body-4"><span >{{ $t("faq.tab22.text24") }}</span></p> -->
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">account_balance_wallet</span>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab22.text12', $t, localPath)"></span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text13") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text14") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text15") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text16") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text17") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text18") }}</span></p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon">
                                <span class="material-symbols-outlined icon" translate="no">account_balance</span>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span v-html="formatContent('faq.tab22.text25', $t, localPath)"></span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text26") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text27") }}</span></p>
                                    <p class="body-4"><span >{{ $t("faq.tab22.text28") }}</span></p>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
const { t, locale } = useI18n();
const route = useRoute();
const localPath = useLocalePath();
import FaqAccordion from '~/components/faq/FaqAccordion.vue'

useFaqSeoMeta("faq.tab22.title1", ["faq.tab22.text1", "faq.tab22.text2", "faq.tab22.text3"]);
</script>
